"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const permissions_pool_1 = require("@app/const/permissions-pool");
const request_1 = require("@app/request");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const workspace_create_sibling_1 = require("@app/component/modals/workspace-create-sibling/workspace-create-sibling");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const use_modal_1 = require("@app/util/modal/use-modal");
const add_workspace_card_1 = require("./add-workspace-card/add-workspace-card");
const connect_1 = __importDefault(require("./connect"));
const workspace_select_card_1 = require("./workspace-select-card");
let alreadyLoadedWS = [];
let alreadyLoadedOrg = [];
let alreadyLoadedUnknownWsMap = {};
// the modal is closed (and unmounted) on every workspace switch, so the country
// filter has to be kept outside of the component to survive switching workspaces
let alreadySelectedCountryFilter = [];
const WorkspaceSelect = ({ me, auth, setOrganizationId, setWorkspaceId, setEnforcedLocality, workspaces, workspaceId, organizationId, isLoading, setModal, getOrganization, workspaceSwitch, }) => {
    const [org, setOrg] = (0, react_1.useState)(alreadyLoadedOrg);
    const [ws, setWs] = (0, react_1.useState)(alreadyLoadedWS);
    const [filter, setFilter] = (0, react_1.useState)('');
    const [countryFilter, setCountryFilter] = react_1.default.useState(alreadySelectedCountryFilter);
    const [isRequestingData, setIsRequestingData] = (0, react_1.useState)(false);
    const [isRequestingOrgData, setIsRequestingOrgData] = (0, react_1.useState)(false);
    const [unknownWsMap, setUnknownWsIdMap] = (0, react_1.useState)(alreadyLoadedUnknownWsMap);
    const hasAccessToAtLeastOneAppSubpageOnWS = react_1.default.useCallback((ws, me) => {
        return me?.acl?.workspaces[ws.id]?.some((permR) => {
            const perm = permR.replace('_write', '').replace('_read', '');
            return (Object.values(permissions_pool_1.PERMISSIONS).some((pType) => typeof pType === 'string' && pType === perm) ||
                Object.values(permissions_pool_1.PERMISSIONS).some((pType) => typeof pType === 'object' && Object.values(pType).includes(perm)));
        });
    }, []);
    const isOrg = util_1.miscUtil.isDayswapsProInterface();
    const selectedId = util_1.miscUtil.isDayswapsProInterface() ? organizationId : workspaceId;
    const { openModal } = (0, use_modal_1.useModal)();
    // the new workspace is created next to the selected one, so there has to be one. the permission is the same one
    // that opens the DS PRO page for creating workspaces (org owners have it too). users of several organizations
    // and of DS PRO organizations (hidden: false) create workspaces in DS PRO instead
    const canCreateWorkspace = !isOrg &&
        (0, util_1.isValue)(workspaceId) &&
        (0, util_1.isValue)(organizationId) &&
        me?.organizations?.length === 1 &&
        me.organizations[0].hidden === true &&
        (me.acl?.organizations?.[organizationId]?.includes(permissions_pool_1.PERMISSIONS_PRO.WORKSPACES.WORKSPACES) ??
            false);
    const workspacesWhereIHavePermissions = workspaces.filter((ws) => hasAccessToAtLeastOneAppSubpageOnWS(ws, me));
    // if I have access to some workspaces where I don't have a role, load the organization data,
    // so I can get the data about those workspaces from there. we store whatever's loaded here in 'unknownWsMap'
    const workspacesWhereIDontHaveRole = workspaces.filter((ws) => !me.roles.some((r) => r.workspaceId === ws.id) &&
        hasAccessToAtLeastOneAppSubpageOnWS(ws, me) &&
        !Object.keys(unknownWsMap).includes(ws.id));
    react_1.default.useEffect(() => {
        if (workspacesWhereIDontHaveRole.length) {
            if (!isRequestingOrgData) {
                setIsRequestingOrgData(true);
                (0, request_1.requestOrganizationBasic)({ organizationId }, auth).then(async (res) => {
                    const newMap = Object.assign({}, unknownWsMap);
                    res?.countries?.forEach((c) => {
                        c?.areas.forEach((a) => {
                            a?.workspaces.forEach((w) => {
                                // this query doesn't select a country on the workspaces themselves,
                                // so we take it from the country node we're iterating over
                                newMap[w.id] = { ...w, country: c.code };
                            });
                        });
                    });
                    // workspaces not found in the current org belong to other organizations —
                    // query each one directly since we don't have their organizationId
                    const stillMissing = workspacesWhereIDontHaveRole.filter((w) => !Object.keys(newMap).includes(w.id));
                    if (stillMissing.length) {
                        const results = await Promise.allSettled(stillMissing.map(async (w) => await (0, request_1.requestWorkspaceSelectInfo)({ id: w.id })));
                        results.forEach((result, index) => {
                            if (result.status === 'fulfilled' && (0, util_1.isValue)(result.value)) {
                                newMap[stillMissing[index].id] = result.value;
                            }
                            else {
                                // last-resort fallback: prevents re-requesting on next render
                                const w = stillMissing[index];
                                newMap[w.id] = {
                                    name: w.name,
                                    enforceLocalities: w.enforceLocalities,
                                    id: w.id,
                                    localities: w.localities,
                                    country: w.country,
                                };
                            }
                        });
                    }
                    setUnknownWsIdMap(newMap);
                    alreadyLoadedUnknownWsMap = newMap;
                    setIsRequestingOrgData(false);
                });
            }
        }
    }, [workspaces, me, unknownWsMap, organizationId, auth, isRequestingOrgData]);
    const handleOnClickWS = async (ws, selectedLocalityId) => {
        if (selectedLocalityId)
            await setEnforcedLocality(selectedLocalityId);
        if (isOrg)
            util_1.routeUtil.navigate('/');
        workspaceSwitch(ws);
    };
    const generateNameShortcut = (name) => {
        let generated = '';
        name.split(' ').forEach((elem, index) => {
            if (index < 3) {
                generated = generated.concat(elem.charAt(0).toUpperCase());
            }
        });
        return generated;
    };
    const handleOnClickOrg = async (org) => {
        await setWorkspaceId(null, { autoSelect: false });
        await setOrganizationId(org.id);
        await getOrganization();
        setModal(null);
        util_1.routeUtil.navigate('/organization');
    };
    const getWsInfo = (workspaceId) => {
        const ret = ws?.find((elem) => workspaceId === elem.id);
        if (!ret) {
            return unknownWsMap[workspaceId];
        }
        return ret;
    };
    const filterDataByFilter = (data) => {
        const normalizedFilter = util_1.miscUtil.normalizeString(filter);
        return data.filter((item) => item.customId?.includes(normalizedFilter) ||
            util_1.miscUtil.normalizeString(item.name)?.includes(normalizedFilter));
    };
    const enrichedData = workspacesWhereIHavePermissions.map((item) => ({
        ...item,
        ...getWsInfo(item.id),
    }));
    // built from the enriched data, not from 'ws' alone — workspaces we can access
    // without having a role on them (DS PRO country/area roles) only ever get their
    // country from 'unknownWsMap', and those countries have to be offered too
    const countryOptions = Array.from(new Set(enrichedData.map((_ws) => _ws.country)).values())
        .filter(util_1.isValue)
        .map((country) => ({
        value: country,
        label: country,
    }));
    const workspacesWithPermission = filterDataByFilter(enrichedData);
    const selectedWorkspace = workspacesWithPermission.find((ws) => ws.id === selectedId);
    (0, react_1.useEffect)(() => {
        async function reqWorkspaceSelect() {
            setIsRequestingData(true);
            const res = await (0, request_1.requestWorkspaceSelect)(auth);
            if (res) {
                const newOrg = res?.organizations?.filter((o) => !o.hidden) || []; // only non-hidden orgs
                setOrg(newOrg);
                alreadyLoadedOrg = newOrg;
                const newWS = res?.workspaces?.filter((ws) => hasAccessToAtLeastOneAppSubpageOnWS(ws, me)) || []; // only workspaces for which we have workspace-type (not organization-type permission)
                setWs(newWS);
                alreadyLoadedWS = newWS;
            }
            setIsRequestingData(false);
        }
        void reqWorkspaceSelect();
    }, []);
    return (react_1.default.createElement(_ui_1.Modal, { size: _ui_1.Modal.SIZES.FULLSCREEN, isLoading: isLoading, headerContent: react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.DIRECTION.ROW, align: _ui_1.Flex.POSITION.CENTER },
            react_1.default.createElement(_ui_1.Text, { weight: _ui_1.Text.WEIGHTS.BOLD, type: _ui_1.Text.TYPES.HEADLINE2, text: (0, util_1.t)('WORKSPACE_SELECTION') }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_16 }),
            react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.LARGE, style: _ui_1.Input.STYLES.BORDERED, ico: 'search', value: filter, placeholder: (0, maybe_unwrap_1.unwrapMaybe)(isRequestingData || isRequestingOrgData ? (0, util_1.t)('LOADING') : (0, util_1.t)('SEARCH')), onChange: (val) => setFilter(val) }),
            (countryOptions?.length ?? 0) > 1 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_16 }),
                react_1.default.createElement(_ui_1.Dropdown, { placeholder: (0, util_1.t)('WS_SETTINGS_WS_COUNTRY'), singleSelect: false, value: countryOptions.filter((country) => countryFilter?.some((opt) => opt === country.value)), options: countryOptions, onChange: (val) => {
                        const newFilter = val.map((_val) => _val.value).filter(util_1.isValue);
                        setCountryFilter(newFilter);
                        alreadySelectedCountryFilter = newFilter;
                    } }))) : null) },
        react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_16 },
            !ws.length && !org.length && (isRequestingData || isRequestingOrgData) ? (react_1.default.createElement(_ui_1.Loader, null)) : (react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.ROW, wrap: 'wrap' },
                !!org.length &&
                    org.map((orgPar) => {
                        const organization = Object.assign({}, orgPar);
                        // @ts-expect-error Property 'shortcut' does not exist on type 'Organization'.
                        organization.shortcut = generateNameShortcut(organization?.name || '');
                        // @ts-expect-error Property 'type' does not exist on type 'Organization'
                        organization.type = 'organizations';
                        return (react_1.default.createElement(workspace_select_card_1.WorkspaceSelectCard, { key: organization.id, isSelected: organization.id === selectedId, color: workspace_select_card_1.WorkspaceSelectCard.COLORS.DARK, onClick: async () => await handleOnClickOrg(organization), data: organization, userId: me.id, isLoading: isRequestingData || isRequestingOrgData }));
                    }),
                selectedWorkspace && (react_1.default.createElement(workspace_select_card_1.WorkspaceSelectCard, { key: selectedWorkspace.id, isSelected: true, color: workspace_select_card_1.WorkspaceSelectCard.COLORS.DEFAULT, onClick: async (selectedLocalityId) => await handleOnClickWS(selectedWorkspace, selectedLocalityId), data: {
                        ...selectedWorkspace,
                        shortcut: generateNameShortcut(selectedWorkspace?.name || ''),
                        type: 'workspaces',
                        enforceLocalities: getWsInfo(selectedWorkspace.id)
                            ?.enforceLocalities,
                        localities: getWsInfo(selectedWorkspace.id)?.localities,
                    }, userId: me.id, isLoading: isRequestingData || isRequestingOrgData })),
                workspacesWithPermission
                    .filter((ws) => ws.id !== selectedId)
                    .filter((ws) => countryFilter.some((country) => country === ws.country) ||
                    countryFilter.length === 0)
                    .sort((a, b) => {
                    const nameA = a?.name?.toLowerCase() ?? '\uffff'; // \uffff is the highest Unicode character, so undefined names will sort after everything else
                    const nameB = b?.name?.toLowerCase() ?? '\uffff';
                    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                })
                    .map((wsPar) => {
                    const workspace = {
                        ...wsPar,
                        type: 'workspaces',
                        shortcut: generateNameShortcut(wsPar?.name || ''),
                    };
                    return (react_1.default.createElement(workspace_select_card_1.WorkspaceSelectCard, { key: workspace.id, isSelected: workspace.id === selectedId, color: workspace_select_card_1.WorkspaceSelectCard.COLORS.DEFAULT, onClick: async (selectedLocalityId) => await handleOnClickWS(workspace, selectedLocalityId), data: workspace, userId: me.id, isLoading: isRequestingData || isRequestingOrgData }));
                }),
                canCreateWorkspace && (react_1.default.createElement(add_workspace_card_1.AddWorkspaceCard, { onClick: () => openModal(workspace_create_sibling_1.WorkspaceCreateSibling, {}) })))),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16 }))));
};
exports.default = (0, connect_1.default)(WorkspaceSelect);
